/* @flow */

import * as React from 'react';
import classnames from 'classnames';

import './button-card.css';

type Props = {
    // Not currently possible with flow
    // ...HTMLButtonElement,
    children: React.Node,
    autoFocus?: boolean,
    isSelected?: boolean,
    /** If true, the card will size vertically according to the content, not the parent's height */
    fitHeight?: boolean,
    /** If true, the card's border will not look "clickable" */
    isDisabled?: boolean,
    isFullWidth?: boolean,
    needsAttention?: boolean,
};

ButtonCard.displayName = 'ButtonCard';

/**
 * This component uses our simple card styling, but acts
 * as a form element, and thus contains hover/active/focus states.
 *
 * This is usually used to select a single rich option, usually as the first selection in a series of forms.
 */
export function ButtonCard({
    children,
    isSelected,
    fitHeight,
    isFullWidth,
    needsAttention,
    isDisabled,
    ...otherProps
}: Props) {
    const styleNames = classnames({
        'button-card': true,
        'button-card--selected': isSelected,
        'button-card--fitHeight': fitHeight,
        'button-card--fullWidth': isFullWidth,
        'button-card--needsAttention': needsAttention,
        'button-card--disabled': isDisabled,
    });

    return (
        <button {...otherProps} disabled={isDisabled} type='button' styleName={styleNames}>
            {children}
        </button>
    );
}
